var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 30.7388C24.0343 30.7388 30.75 24.023 30.75 15.7388C30.75 7.4545 24.0343 0.73877 15.75 0.73877C7.46573 0.73877 0.75 7.4545 0.75 15.7388C0.75 24.023 7.46573 30.7388 15.75 30.7388Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7129 16.9465V23.1307H21.1275V17.3609C21.1275 15.9122 20.6099 14.9229 19.3117 14.9229C18.321 14.9229 17.7325 15.5889 17.4726 16.2339C17.3782 16.4644 17.3539 16.7844 17.3539 17.1077V23.1304H13.7682C13.7682 23.1304 13.8163 13.3584 13.7682 12.3468H17.3541V13.875C17.3469 13.887 17.3367 13.8988 17.3303 13.9103H17.3541V13.875C17.8306 13.1418 18.6804 12.0936 20.5855 12.0936C22.9444 12.0936 24.7129 13.6349 24.7129 16.9465ZM10.0172 7.1488C8.79072 7.1488 7.98828 7.95391 7.98828 9.0117C7.98828 10.047 8.76745 10.8754 9.97017 10.8754H9.99343C11.244 10.8754 12.0216 10.047 12.0216 9.0117C11.9978 7.95391 11.244 7.1488 10.0172 7.1488ZM8.20139 23.1307H11.7857V12.3468H8.20139V23.1307Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.75 0.739746)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.13e4ca4456071ff9f8023c250e9c0749.svg";
export { ForwardRef as ReactComponent };